module.exports = __webpack_public_path__ + "images/emoji/es.8a3a5b8bbf75832d5c11.png";